import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

// TODO: Use the NotificationService instead
@Injectable()
export class OrderNotificationService {
  
  constructor(
    private translateService: TranslateService,
    private toastrService: ToastrService
  ) {}

  get orderDeclinedMessage() {
    return this.getTranslation(
      'ORDER-LIST.TOAST-DECLINED'
    );
  }
  get orderAcceptedMessage() {
    return this.getTranslation(
      'ORDER-LIST.TOAST-ACCEPTED'
    );
  }
  get orderAcceptedRejectedFailureMessage() {
    return this.getTranslation(
      'ORDER-LIST.TOAST-CONFIRM-ACTION-FAILED'
    );
  }
  get dataSavedSuccessfullyMessage() {
    return this.getTranslation(
      'ORDER-TABLE.TOAST-SUCCESS'
    );
  }
  get dataSavedFailureMessage() {
    return this.getTranslation(
      'ORDER-TABLE.TOAST-FAILED'
    );
  }
  get dossierOrderAcceptedMessage() {
    return this.getTranslation(
      'ORDER-LIST.DOSSIER-ACCEPTED'
    );
  }
  get dossierOrderAcceptedRejectedMessageFailure() {
    return this.getTranslation(
      'ORDER-LIST.DOSSIER-ACTION-FAILED'
    ); 
  }
  get dossierOrderDeclinedMessage() {
    return this.getTranslation(
      'ORDER-LIST.DOSSIER-DECLINED'
    );
  }
  get generalErrorMessage() {
    return this.getTranslation('ORDER-TABLE.TOAST-FAILED');
  }
  get transportInfoSavedMessage() {
    return this.getTranslation (
      'ORDER-LIST-DETAILS.TS-TRANSP-SAVED-MESSAGE'
    );
  }
  get transportInfoNotSavedMessageFailure() {
    return this.getTranslation (
      'ORDER-LIST-DETAILS.TS-TRANSP-FAILURE-MESSAGE'
    );
  }
  get cannotBookTimeslotMessageFailure() {
    return this.getTranslation (
      'ORDER-LIST.TIMESLOT-BOOKING-DENIED'
    );
  }
  get preventiveActionSavedMessage() {
    return this.getTranslation (
      'INCIDENT-DETAILS.SAVED-PREVENTIVE-MESSAGE'
    );
  }

  get correctiveActionSavedMessage() {
    return this.getTranslation (
      'INCIDENT-DETAILS.SAVED-CORRECTIVE-MESSAGE'
    );
  }

  get rootcauseSavedMessage() {
    return this.getTranslation (
      'INCIDENT-DETAILS.SAVED-ROOTCAUSE-MESSAGE'
    );
  }
  get incidentNotSavedMessage() {
    return this.getTranslation (
      'INCIDENT-DETAILS.SAVE-FAILURE-MESSAGE'
    );
  }

  showCorrectiveActionSavedMessage() {
    this.toastrService.success(this.correctiveActionSavedMessage);
  }

  showPreventiveActionSavedMessage() {
    this.toastrService.success(this.preventiveActionSavedMessage);
  }

  showRootcauseSavedMessage() {
    this.toastrService.success(this.rootcauseSavedMessage);
  }

  showIncidentSaveFailureMessage() {
    this.toastrService.error(this.incidentNotSavedMessage);
  }

  showDataSavedFailureMessage() {
    this.toastrService.error(this.dataSavedFailureMessage);
  }

  showDataSavedSuccessfullyMessage() {
    this.toastrService.success(this.dataSavedSuccessfullyMessage);
  }

  showGeneralErrorMessage() {
    this.toastrService.error(this.generalErrorMessage);
  }

  showOrderAcceptedMessage() {
    this.toastrService.success(this.orderAcceptedMessage);
  }

  showOrderDeclinedMessage() {
    this.toastrService.success(this.orderDeclinedMessage);
  }

  showOrderAcceptedRejectedFailureMessage() {
    this.toastrService.error(this.orderAcceptedRejectedFailureMessage);
  }

  showDossierOrderAcceptedMessage() {
    this.toastrService.success(this.dossierOrderAcceptedMessage);
  }

  showDossierOrderDeclinedMessage() {
    this.toastrService.success(this.dossierOrderDeclinedMessage);
  }

  showDossierOrderAcceptedRejectedMessageFailure() {
    this.toastrService.error(this.dossierOrderAcceptedRejectedMessageFailure);
  }
  
  showTransportInformationSavedMessage() {
    this.toastrService.success(this.transportInfoSavedMessage);
  }

  showTimeslotBookingErrorMessage () {
    this.toastrService.error(this.cannotBookTimeslotMessageFailure);
  }

  showTransportInformationNotSavedMessageFailure() {
    this.toastrService.error(this.transportInfoNotSavedMessageFailure);
  }

  private getTranslation(key: string): string {
    let translation: string;
    this.translateService.get(key).subscribe(message => {
      translation = message;
    });
    return translation;
  }
}
